export default "__VITE_ASSET__dF_eRzW8__"